/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import clamp from 'cio/utils/clamp';
import VisualWorkflowBuilderService from 'cio/services/visual-workflow-builder';
import { Task } from 'ember-concurrency';
import { FlyInputEvent } from '@customerio/fly-components/types/fly-components/events';
import ActionModel from 'cio/models/action';
import AnalyticsService from 'cio/services/analytics';
import { VWBTab } from 'cio/utils/visual-workflow-builder/types';

interface EditSidebarSplitEditorArgs {
  actionAbstract: any;
  tab: VWBTab;
  isSaving: boolean;
  onSelect: (action: ActionModel) => unknown;
  onDeselect: () => unknown;
  showDiscardModal: () => unknown;
  pauseTestTask: Task<unknown, []>;
  resumeTestTask: Task<unknown, []>;
  hasReadOnlyPermission: boolean;
}
export default class EditSidebarSplitEditor extends Component<EditSidebarSplitEditorArgs> {
  @service analytics!: AnalyticsService;
  @service visualWorkflowBuilder!: VisualWorkflowBuilderService;

  private allocationChanged(index: number, value: string) {
    let targetValue = clamp(parseInt(value), 100, 0);
    let allocations = this.args.actionAbstract.splitAllocations;
    allocations[index].set('allocation', targetValue);

    if (allocations.length === 2) {
      allocations[(index + 1) % 2].set('allocation', 100 - targetValue);
    }
  }

  @action
  allocationChangedSlider(value: string) {
    this.allocationChanged(0, value);
  }

  @action
  allocationChangedInput(index: number, event: FlyInputEvent<HTMLInputElement>) {
    this.allocationChanged(index, event.target.value);
  }

  @action
  onEdit(actionModel: ActionModel) {
    this.args.onSelect(actionModel);

    if (this.args.actionAbstract.isDirty) {
      this.args.showDiscardModal();
    }

    this.analytics.track('campaign', 'workflow_existing_item_clicked', {
      model: actionModel.campaign,
      action: actionModel,
      trayTab: this.args.tab,
    });
  }
}
